(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const faqImage = document.querySelector(".section-faq .image-block img");
    if (!faqImage) return;

    const headers = document.querySelectorAll(".section-faq .details__header");

    // Set default image from the first header that has one
    const firstWithImage = Array.from(headers).find(h => h.dataset.image);
    if (firstWithImage) {
      faqImage.src = firstWithImage.dataset.image;
      faqImage.srcset = firstWithImage.dataset.image;
    }

    headers.forEach(header => {
      header.addEventListener("click", () => {
        const imageUrl = header.dataset.image;
        if (!imageUrl) return;

        const accordionCustom = header.closest('accordion-custom');
        const isCurrentlyOpen = accordionCustom
          ? accordionCustom.hasAttribute('open')
          : header.parentElement.hasAttribute('open');

        if (isCurrentlyOpen) {
          faqImage.src = imageUrl;
          faqImage.srcset = imageUrl;
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    // Close-siblings logic is handled inside accordion-custom.js
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-availability"] && !Shopify.designMode) return;
  try {
    (function () {
  // Delivery date
  var dateEl = document.querySelector('.product-availability__delivery-date');
  if (dateEl) {
    var d = new Date();
    d.setDate(d.getDate() + 14);
    dateEl.textContent = String(d.getDate()).padStart(2, '0') + '/' +
      String(d.getMonth() + 1).padStart(2, '0') + '/' + d.getFullYear();
  }

  var el = document.getElementById('product-availability-indicator');
  if (!el) return;

  var section = el.closest('.shopify-section, dialog');
  if (!section) return;

  // Create OOS popup once per page and append to body (escapes stacking contexts)
  if (!document.getElementById('product-oos-backdrop')) {
    var _bd = document.createElement('div');
    _bd.className = 'product-oos-backdrop';
    _bd.id = 'product-oos-backdrop';
    _bd.hidden = true;
    var _bn = document.createElement('div');
    _bn.className = 'product-oos-banner';
    _bn.id = 'product-oos-banner';
    _bn.hidden = true;
    _bn.innerHTML =
      '<p class="product-oos-banner__text">This product is currently out of stock. We&#x27;re not accepting new orders at this time.</p>' +
      '<div class="product-oos-banner__actions">' +
      '<button class="button button--secondary" id="product-oos-ok" type="button">OK</button>' +
      '</div>';
    document.body.appendChild(_bd);
    document.body.appendChild(_bn);
  }

  function showOosPopup() {
    var bd = document.getElementById('product-oos-backdrop');
    var bn = document.getElementById('product-oos-banner');
    var ok = document.getElementById('product-oos-ok');
    if (!bn || !ok) return;
    if (bd) bd.hidden = false;
    bn.hidden = false;
    function close() {
      if (bd) bd.hidden = true;
      bn.hidden = true;
      ok.removeEventListener('click', close);
      if (bd) bd.removeEventListener('click', close);
    }
    ok.addEventListener('click', close);
    if (bd) bd.addEventListener('click', close);
  }

  function applyOosState(status) {
    var atcBtn = section.querySelector('button[name="add"]');
    if (!atcBtn) return;
    atcBtn.classList.toggle('product-atc--oos', status === 'out_of_stock');
  }

  // window capture fires before document capture (where the theme component system lives)
  window.addEventListener('click', function (e) {
    var atcBtn = section.querySelector('button[name="add"]');
    if (!atcBtn || !atcBtn.classList.contains('product-atc--oos')) return;
    if (e.target !== atcBtn && !atcBtn.contains(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showOosPopup();
  }, true);

  // Apply initial state
  var initialMatch = el.className.match(/product-availability--(\S+)/);
  applyOosState(initialMatch ? initialMatch[1] : 'in_stock');

  section.addEventListener('variant:update', function (e) {
    var newHtml = e.detail && e.detail.data && e.detail.data.html;
    if (!newHtml) return;
    var newEl = newHtml.querySelector('#product-availability-indicator');
    if (!newEl) return;
    el.className = newEl.className;
    var oldLabel = el.querySelector('.product-availability__label');
    var newLabel = newEl.querySelector('.product-availability__label');
    if (oldLabel && newLabel) oldLabel.textContent = newLabel.textContent;
    var statusMatch = newEl.className.match(/product-availability--(\S+)/);
    applyOosState(statusMatch ? statusMatch[1] : 'in_stock');
  });
})();
  } catch(e) { console.error(e); }
})();

})();
